/**
 * Red Domains API
 * Axios-based API calls matching the existing project pattern.
 */
import api from '../../../../api/client'
import { invalidateEntity } from '../../../../api/cacheInvalidation'

export async function fetchRedDomains() {
  const { data } = await api.get('/red-domains')
  return Array.isArray(data?.domains) ? data.domains : []
}

export async function saveRedDomains(domains) {
  const { data } = await api.post('/red-domains/save', { domains })
  invalidateEntity.productivity()
  return data
}

export async function deleteRedDomain(id) {
  const { data } = await api.delete(`/red-domains/${id}`)
  invalidateEntity.productivity()
  return data
}

